// extracted by mini-css-extract-plugin
export default {"svg-container":"SpinnerLoaderSvg_svg-container__sB8yc"};